module.exports = __webpack_public_path__ + "static/media/default-product.e4277596.png";